import { useAppDispatch } from 'store/hooks';
import { useEffect } from 'react';
import permissionSelectors from '../selectors';
import permissionActions from '../actions';

export const useGetPermissionConfigFiltered = () => {
  const data = permissionSelectors.getPermissionConfigFiltered();
  const dispatch = useAppDispatch();

  const mutate = () => { 
    dispatch(permissionActions.getPermissionConfig.fetch());
  };

  useEffect(() => {
    mutate();
  }, []);

  return [
    data,
    mutate
  ] as const;
};